import React, { useState, useEffect } from 'react';
import { DataService } from '../services/dataService';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { SiteConfig } from '../types';

const Contact: React.FC = () => {
  const [config, setConfig] = useState<SiteConfig>(DataService.getConfig());
  const { language, t } = useLanguage();

  useEffect(() => {
    const handler = (e: any) => {
      try {
        const db = e?.detail?.db || DataService.getDB();
        if (db && db.config) {
          setConfig(db.config);
        }
      } catch (err) {
        console.warn('Contact db_updated handler error', err);
      }
    };

    window.addEventListener('db_updated', handler as EventListener);

    // initial sync
    try {
      const db = DataService.getDB();
      if (db && db.config) {
        setConfig(db.config);
      }
    } catch (err) {
      console.warn('Contact initial DB load error', err);
    }

    return () => window.removeEventListener('db_updated', handler as EventListener);
  }, []);


  return (
    <div className="relative py-12 px-4 bg-white min-h-[80vh]">
      <img
          src="/images/t5.jpeg"
        alt=""
        onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        className="absolute inset-0 w-full h-full object-cover opacity-10 pointer-events-none"
      />
      <div className="relative container mx-auto max-w-6xl z-10">
        <h1 className="text-4xl font-serif font-bold text-temple-orange-900 mb-12 text-center">{t('Contact Us', 'ബന്ധപ്പെടുക')}</h1>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-stretch">
          {/* Contact Info */}
          <div className="bg-temple-orange-50/90 p-8 lg:p-12 rounded-2xl flex flex-col justify-center shadow-sm">
            <h2 className="text-3xl font-bold text-gray-800 mb-8">{t('Get in Touch', 'വിലാസം')}</h2>
            <div className="space-y-8">
              <div className="flex items-start gap-6">
                <div className="bg-white p-4 rounded-full shadow-sm text-temple-orange-600 shrink-0">
                  <MapPin size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{t('Address', 'വിലാസം')}</h3>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {language === 'en' ? config.address : (config.addressMal || config.address)}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-6">
                <div className="bg-white p-4 rounded-full shadow-sm text-temple-orange-600 shrink-0">
                  <Phone size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{t('Phone', 'ഫോൺ')}</h3>
                  <p className="text-blue-600 hover:text-blue-800 transition-colors">{config.phone}</p>
                 
                </div>

              </div>

              <div className="flex items-start gap-6">
                <div className="bg-white p-4 rounded-full shadow-sm text-temple-orange-600 shrink-0">
                  <Mail size={28} />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{t('Email', 'ഇമെയിൽ')}</h3>
                  <p className="text-blue-600 hover:text-blue-800 transition-colors">{config.email}</p>
                </div>
              </div>
            </div>
            
            <div className="mt-12 p-6 bg-white/60 rounded-xl border border-orange-100">
                <h4 className="font-bold text-temple-orange-800 mb-2">{t('Temple Timing', 'ദർശന സമയം')}</h4>
                <div className="flex justify-between text-sm text-gray-700">
                    <span>{t('Morning', 'രാവിലെ')}</span>
                    <span className="font-medium">5:30 AM - 10:00 AM</span>
                </div>
                <div className="flex justify-between text-sm text-gray-700 mt-2">
                    <span>{t('Evening', 'വൈകുന്നേരം')}</span>
                    <span className="font-medium">5:30 PM - 7:00 PM</span>
                </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="h-full min-h-[400px] rounded-2xl overflow-hidden shadow-lg border-4 border-orange-50 relative">
            <iframe 
                   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3931.590009361043!2d76.50471197450644!3d9.800715176433235!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07d7796e9c390b%3A0x7a7e27cd09dd39ac!2sArunoottimangalam%20bhagavathy%20temple!5e0!3m2!1sen!2sin!4v1765905972618!5m2!1sen!2sin"    width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              loading="lazy"
              className="absolute inset-0 w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
